import { render, staticRenderFns } from "./FlowApproveAINode.vue?vue&type=template&id=42b40315&scoped=true&"
import script from "./FlowApproveAINode.vue?vue&type=script&lang=js&"
export * from "./FlowApproveAINode.vue?vue&type=script&lang=js&"
import style0 from "./FlowApproveAINode.vue?vue&type=style&index=0&id=42b40315&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b40315",
  null
  
)

export default component.exports